/**
 * The application's default properties related to the CSS box model such as
 * margins, borders, padding.
 */
export const BoxModel = {
    /**
     * The application's default margin when non-zero margin is necessary.
     */
    margin: 10,

    /**
     * The application's default padding when non-zero padding is necessary.
     */
    padding: 10
};
